import { useMemo } from 'react'

import { Nullable } from 'cng-common/models/utils'
import { IDataProviderSort, IPaging, Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

const DEFAULT_PAGING: IPaging = {
  page: 0,
  pageSize: 1000,
}

type StaticCrudOptions<T> = {
  items: T[]
  keyField: keyof T
  sorting?: IDataProviderSort | IDataProviderSort[] | undefined
  paging?: IPaging
  hierarchyField?: string
  hierarchyRoot?: Nullable<string>
}

export function useStaticCrud<T>({
  items,
  keyField,
  sorting,
  paging = DEFAULT_PAGING,
  hierarchyField,
  hierarchyRoot,
}: StaticCrudOptions<T>): Crud<T> {
  return useMemo(
    () =>
      new Crud<T>({
        fetcher: new Static(items),
        keyField: keyField as string,
        defaultPaging: paging,
        defaultSort: sorting,
        hierarchyField,
        hierarchyRoot,
        store: {} as any,
      }),
    [items, keyField, paging, hierarchyField, hierarchyRoot, sorting]
  )
}
